import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TINY_MCE_INIT = {
  menubar: '',
  entity_encoding : "raw", 
  encoding: "UTF-8",
  plugins: "lists paste",
  toolbar: 'bold italic underline | numlist bullist | alignleft aligncenter alignright alignjustify',
  branding: false,
  //forced_root_block: false,
  //invalid_elements: 'span',
  //extended_valid_elements: 'span[!class]',
  paste_as_text: true
};

const RichText = ({ name, value, readOnly, onChange, init = {} }) => {
  return (
    <Editor
      textareaName={name}
      init={{
        ...TINY_MCE_INIT,
        ...init,
      }}
      disabled={readOnly}
      value={value || ''}
      onEditorChange={onChange}
    />
  );
};

export default RichText;



// WEBPACK FOOTER //
// ./src/modules/common/components/RichText.js